import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../store/rootReducer';
import { useProductsInfos } from '../../common/hooks/useProductsInfos';
import { RecommendationsBlock } from '../../recommendations/components/RecommendationsBlock';
import { loadRecommendationsHomemade } from '../../recommendations/utils';
export const CartRecommendations = () => {
  const { items, total, shippingAmount } = useSelector((state: RootState) => state.cart.cart);
  const { isFetching } = useSelector((state: RootState) => state.account);

  const safeTotal = Number(total) || 0;
  const safeShippingAmount = Number(shippingAmount) || 0;
  const totalAmount = parseFloat((safeTotal - safeShippingAmount).toFixed(2));
  const productsData = items.map((item) => `${item.productRef}-${item.colorRef}`);
  const [recommendedRefs, setRecommendedRefs] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const { cart_recommendation_title: title } = useSelector((state: RootState) => state.cms.cart);
  const { hits } = useProductsInfos(Object.values(recommendedRefs).flat());

  useEffect(() => {
    setRecommendedRefs([]);
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const data = await loadRecommendationsHomemade({
          type: 'cart',
          params: {
            amount: totalAmount,
            products: [...productsData],
          },
        });
        setRecommendedRefs(data.recommendations ?? []);
      } catch (e) {
        setRecommendedRefs([]);
      } finally {
        setLoading(false);
      }
    };
    if (totalAmount > 0 && items.length > 0 && !isFetching) {
      fetchRecommendations();
    }
  }, [totalAmount, items, isFetching]);

  if (!recommendedRefs?.length || loading) {
    return null;
  }

  return <RecommendationsBlock id="cart-page" title={title} hits={hits} />;
};
